import { createSlice } from "@reduxjs/toolkit";

export const tabActive = createSlice({
  name: "tabActive",
  initialState: {
    tabs: 0,
  },
  reducers: {
    setTabActive: (state, action) => {
      state.tabs = action.payload;
    },
  },
});

export const { setTabActive } = tabActive.actions;

export default tabActive.reducer;
